import React from 'react'
import clsx from 'clsx'
import { Information, ShieldTick } from 'iconsax-react'

import useStyles from './styles'

const Input = ({ error, valid, children, className, input }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)}>
      <div className={classes.inputArea}>
        {children}

        <div className={classes.inputHolder}>
          {valid && <ShieldTick variant='Bold' className={classes.shield} />}

          {input}
        </div>
      </div>

      {error && (
        <label className={classes.error}>
          <Information variant='Bold' className='icon' />
          {error}
        </label>
      )}
    </div>
  )
}

export default Input
